import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import { Link } from "react-router-dom";
import MUIDataTable from 'mui-datatables';
import { Box, Grid, IconButton, Tooltip, Paper } from '@material-ui/core';
import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import Toolbar from './Toolbar/Toolbar';
import { StateContext, DispatchContext } from '../../../context/Provider';

import {
    DeleteForeverTwoTone as DeleteForeverTwoToneIcon,
    Visibility as VisibilityIcon
} from '@material-ui/icons';

const Ebooks = (props) => {
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [ebooks, setEbooks] = useState([]);

    const [columns, setColumns] = useState([
        { label: "#", name: "id", options: {setCellProps: () => ({ style: { width: "5%" }})} },
        { label: "Book Title", name: "title" },
        { label: "Classroom / Subject", name: "classroom" },
        { label: "file_url", name: "file_url", options: { display: false } },
        { label: "Created At", name: "created_at" },
        { label: 'Actions', name: "actions",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Tooltip title="View E-book PDF">
                                <IconButton
                                    component={Link}
                                    to={`/e-books/${tableMeta.rowData[0]}`}
                                    // target="_blank"
                                    // rel="noopener noreferrer"
                                >
                                    <VisibilityIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>

                            { authState.user.role_id !== 5 && (
                                <IconButton
                                    aria-label="delete"
                                    onClick={() => {
                                        window.confirm(`Are you sure you want to Delete this e-book?`) && deleteEbook(tableMeta.rowData[0])
                                    }}>
                                    <Tooltip title="Delete E-book">
                                        <DeleteForeverTwoToneIcon fontSize="default" />
                                    </Tooltip>
                                </IconButton>
                            )}
                        </>
                    )
                }
            }
        }
    ]);

    const [options, setOptions] = useState({
        filter: true,
        filterType: 'dropdown',
        responsive: 'standard',
        rowsPerPage: 10,
        selectableRows: false,
        customToolbar: () => {
            if (authState.user.role_id === 4 || authState.user.role_id === 3) {
                return (<Toolbar fetchEbooks={fetchEbooks} />);
            }
        }
    });

    async function fetchEbooks() {
        try {
            const response = await axiosConfig.get(`/e-books`);
            const { data } = response.data;

            const ebooksArr = [];
            data.map(function (data, index) {
                ebooksArr.push({
                    id: data.id,
                    classroom: `${data.classroom} (${data.section})`,
                    title: data.title,
                    file_url: data.file_url,
                    is_active: data.is_active,
                    created_at: data.created_at
                });
            });

            setEbooks(ebooksArr);

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    async function deleteEbook(id) {
        try {

            const response = await axiosConfig.post(`/e-books/${id}`, {
                _method: "DELETE"
            });

            const { status_code, message } = response.data;
            console.log(message);

            if (status_code === 'ok') {
                globalDispatch({type: 'setSnackbarMsg', value: 'E-book removed successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});
                fetchEbooks();
            }

            globalDispatch({type: 'setIsLoading', value: false});
            setTimeout(() => {
                globalDispatch({type: 'setIsOpenSnackbar', value: false});
            }, 1200);

        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setShowTabs', value: false});
        globalDispatch({ type: "setIsLoading", value: true});

        const source = axiosConfig.CancelToken.source();
        fetchEbooks();
        return () => {
            source.cancel();
        }

    }, []);

    return (
        <ResponsiveLayout>
            <Grid container component="main" justify="center">
                <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <MUIDataTable
                        title={"List of E-books"}
                        data={ebooks}
                        columns={columns}
                        options={options}
                    />
                </Grid>
            </Grid>
        </ResponsiveLayout>
    );
}

export default Ebooks;